import React, { useState } from "react";

import { Card, Typography, Pagination, Table, Popconfirm, message } from "antd";
import CommonTopDetails from "../../../../components/AdminComponents/CommonTopDetails";
import { useParams } from "react-router-dom";
import useCommonListing from "../../../../components/AdminComponents/customHooks/useCommonListing";
import { Tag, Tooltip, Space } from "antd";
import {
  CheckCircleOutlined,
  PlayCircleOutlined,
  UserAddOutlined,
  BarsOutlined,
} from "@ant-design/icons";
import { useSelector } from "react-redux";
import { GetFormattedDateTime } from "../../../../components/utils/DateTimeUtils";
import BulkCourseUsersAdd from "../../../../components/AdminComponents/Modals/BulkCourseUsersAdd";
import { DeleteTwoTone } from "@ant-design/icons";
import axiosInstance from "../../../../api/Axios";
import UserViewExpandable from "./UserViewExpandable";

const { Title } = Typography;
const Users = (props) => {
  const userInfo = useSelector((state) => state.user);
  const { id } = useParams();
  const [loadAgain, setLoadAgain] = useState(false);
  const LoadAPI = () => {
    setLoadAgain((prev) => !prev);
  };
  const [messageApi, contextHolder] = message.useMessage();
  const {
    data,
    itemsLength,
    loading,
    filterData,
    onShowSizeChange,
    onPageChange,
    handleSearchChange,
    // setFilterData,
    // handleSwitchChange,
    // handleClearAll,
    // setFilterUrl,
  } = useCommonListing({
    passSize: 10,
    passPage: 1,
    passURL: `learn/bundleuserlist/${id}/`,
    loadAgain: loadAgain,
  });
  // eslint-disable-next-line no-unused-vars
  const { pageSize, currentPage, active, filter_url } = filterData;
  const [isBulkModalOpen, setIsBulkModalOpen] = useState(false);
  const DeleteSuccessfull = () => {
    messageApi.open({
      type: "success",
      content: "Trainer has been removed successfully.",
      duration: 5,
    });
    props?.LoadUser();
    LoadAPI();
  };
  const DeleteFalied = () => {
    messageApi.open({
      type: "error",
      content: "Failed to remove trainer.",
      duration: 5,
    });
  };
  function getCookie(name) {
    const cookies = document.cookie.split("; ");
    for (let i = 0; i < cookies.length; i++) {
      const [cookieName, cookieValue] = cookies[i].split("=");
      if (cookieName === name) {
        return cookieValue;
      }
    }
    return null;
  }
  const csrfToken = getCookie("csrftoken");
  const handleDelete = async (record) => {
    try {
      await axiosInstance.delete(
        `/learn/bundleuserdelete/${record?.bundle_course_id}/${record?.id}/`,
        {
          headers: {
            "X-CSRFToken": csrfToken,
          },
        }
      );
      DeleteSuccessfull();
    } catch (err) {
      DeleteFalied();
    }
  };
  const columns = [
    {
      title: "User ID",
      dataIndex: "user_id",
      key: "user_id",
      width: 135,
    },
    {
      title: "User Name",
      dataIndex: "full_name",
      key: "full_name",
      width: 140,
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      width: 200,
    },
    {
      title: "Progress Summary",
      key: "progress_summary",
      render: (text, record) => {
        const { completed_count, enroled_count, started_count, total_count } =
          record;

        return (
          <Space size="small" direction="vertical">
            <Space wrap>
              <Tooltip title="Total Assigned">
                <Tag
                  icon={<BarsOutlined />}
                  color="default"
                  style={{ fontSize: "13.25px" }}
                >
                  {total_count}
                </Tag>
              </Tooltip>
              <Tooltip title="Enrolled">
                <Tag
                  icon={<UserAddOutlined style={{ color: "blue" }} />}
                  color="default"
                  style={{ fontSize: "13.25px" }}
                >
                  {" "}
                  {enroled_count}
                </Tag>
              </Tooltip>
              <Tooltip title="Started">
                <Tag
                  icon={<PlayCircleOutlined style={{ color: "#ec7a1c" }} />}
                  color="default"
                  style={{ fontSize: "13.25px" }}
                >
                  {" "}
                  {started_count}
                </Tag>
              </Tooltip>
              <Tooltip title="Completed">
                <Tag
                  icon={<CheckCircleOutlined style={{ color: "green" }} />}
                  color="default"
                  style={{ fontSize: "13.25px" }}
                >
                  {" "}
                  {completed_count}
                </Tag>
              </Tooltip>
            </Space>
          </Space>
        );
      },
      width: 280,
    },
    {
      title: "Department",
      dataIndex: "department_name",
      key: "department_name",
      width: 250,
      ellipsis: true,
    },
    {
      title: "Due Date",
      dataIndex: "due_date",
      key: "due_date",
      width: 150,
      render: GetFormattedDateTime,
    },
    ...(props?.ImpersonateAccess
      ? [
          {
            title: "Actions",
            dataIndex: "id",
            key: "id",
            align: "center",
            width: 100,
            fixed: "right",
            render: (text, record) =>
              record?.is_delete ? (
                <div style={{ display: "flex", justifyContent: "center" }}>
                  <Popconfirm
                    title={"Delete User"}
                    description=" "
                    onConfirm={() => handleDelete(record)}
                    // onCancel={cancel}
                    okText="Yes"
                    cancelText="No"
                    placement="leftTop"
                  >
                    <DeleteTwoTone
                      style={{
                        cursor: "pointer",
                        fontSize: "1.6rem",
                        marginLeft: "0.7rem",
                      }}
                      title="Archive"
                      twoToneColor="#eb2f96"
                    />
                  </Popconfirm>
                </div>
              ) : null,
          },
        ]
      : []),
  ];
  const { data: data2 } = useCommonListing({
    passSize: 100,
    passPage: 1,
    passURL: `learn/bundledetailslist/?bundle_id=${id}`,
  });
  console.log(data2);
  return (
    <Card style={{ width: "100%", marginBottom: "10px" }} hoverable>
      {contextHolder}
      <Title level={5} style={{ marginInline: "10px" }}>
        Associated Users Summary
      </Title>
      <CommonTopDetails
        title={`Bundle Users`}
        titleSuffix={`${itemsLength || 0} user(s)`}
        searchPlaceholder="Search by..."
        searchAction={handleSearchChange}
        showAddButton={props?.ImpersonateAccess}
        filterAction={false}
        marginPass="15px"
        paddingInlinepass="10px"
        topSizeAdd="5px"
        addButtonProps={{
          modalType: "PopUP",
          modalProps: () => setIsBulkModalOpen((prev) => !prev),
        }}
      />
      <Table
        columns={columns}
        dataSource={data}
        rowKey="id"
        size="small"
        loading={loading}
        className="table-container"
        style={{ margin: "1rem" }}
        pagination={false}
        scroll={{
          x: 400,
        }}
        bordered
        expandable={{
          expandedRowRender: (record) => (
            <UserViewExpandable record={record} id={id} />
          ),
          rowExpandable: (record) => true,
        }}
      />

      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          padding: "1rem",
        }}
      >
        <Pagination
          size="small"
          showSizeChanger
          onShowSizeChange={onShowSizeChange}
          onChange={onPageChange}
          pageSizeOptions={["5", "10", "15", "20", "50"]}
          //   showQuickJumper
          current={currentPage}
          defaultPageSize={pageSize}
          total={itemsLength}
        />
      </div>
      <BulkCourseUsersAdd
        open={isBulkModalOpen}
        onClose={() => setIsBulkModalOpen(false)}
        userInfo={userInfo}
        course_id={id}
        LoadAPI={LoadAPI}
        callMain={props.LoadUser}
        course_ids={data2?.map((id) => id?.child_course_id) || []}
        from="bundle"
        bundle_id={id}
        ShowMessage={props?.data1?.user_count > 0 ? true : false}
      />
    </Card>
  );
};

export default Users;
